
import React from "react";
import { Link } from "react-router-dom";
import { EmployeeAppNav } from "./EmployeeAppNav";
import { ProfileDropdown } from "./ProfileDropdown";

import { NotificationBell } from "@/components/shared/NotificationBell";

export const CandidateNav = React.memo(() => {
  console.log('[CandidateNav] Rendering');
  
  return (
    <nav className="fixed top-0 left-0 right-0 z-[100] bg-background border-b border-border">
      <div className="container max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src="/lovable-uploads/e7e0cd62-757f-4e57-b3bf-42cffdc8d843.png" 
              alt="Testera Logo" 
              className="h-8 w-8"
            />
            <span className="text-2xl font-bold text-foreground tracking-tight">
              Testera
            </span>
          </Link>
          <div className="flex items-center space-x-4">
            <EmployeeAppNav />
            <ProfileDropdown />
            <NotificationBell />
          </div>
        </div>
      </div>
    </nav>
  );
});

CandidateNav.displayName = 'CandidateNav';
